import React from "react";

export const Overline = ({ children, className = "", muted = false }) => (
  <div className={`overline ${muted ? "text-ag-text-muted" : "text-gold"} ${className}`}>{children}</div>
);

export const SectionDivider = ({ className = "" }) => (
  <div className={`flex items-center justify-center gap-6 py-4 ${className}`} aria-hidden="true">
    <div className="h-px flex-1 max-w-[120px] bg-gradient-to-r from-transparent via-glow/30 to-gold/40" />
    <div className="w-1.5 h-1.5 rounded-full bg-gold" style={{ boxShadow: "0 0 12px rgba(198,168,107,0.6)" }} />
    <div className="h-px flex-1 max-w-[120px] bg-gradient-to-l from-transparent via-glow/30 to-gold/40" />
  </div>
);

export const GoldRule = ({ className = "" }) => (
  <div className={`h-px w-12 bg-gradient-to-r from-transparent via-gold to-transparent ${className}`} />
);

export default SectionDivider;
